import { Chip } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "i18n-fe";
import { useStoragePersistenceStatus } from "../hooks/useStoragePersistenceStatus";

// Card #2829 (docs/score/scribe-resilience.md gap G13, AC4/AC5). A refused
// navigator.storage.persist() means this station's IndexedDB cache is a
// candidate for silent eviction under storage pressure -- exactly the
// station #2829 exists to flag BEFORE it matters. Plain language, always
// visible while true (kiosk doctrine: no dismiss, no escape hatch -- the
// condition clears itself the moment persisted() next reports true, same
// self-clearing rule as every other alarm in this app).
//
// Renders nothing when: the check hasn't run yet (info === null), the API is
// unsupported (nothing this app can do about that, and most real devices
// support it), or persistence was granted.
export default function StoragePersistenceChip() {
  const info = useStoragePersistenceStatus();
  const { t } = useTranslation("score");

  if (!info || !info.supported || !info.refused) return null;

  return (
    <Chip
      data-testid="storage-not-persistent"
      size="small"
      icon={<WarningAmberIcon />}
      label={t("status.storageNotPersistent")}
      color="warning"
      variant="filled"
      sx={{
        fontWeight: 600,
        "& .MuiChip-icon": { color: "warning.contrastText" },
      }}
    />
  );
}
